import { FC, useState, ReactElement } from "react"
import { TasksService, CreateTaskRequestSchema } from "../sdk"
import { Controller, useForm } from "react-hook-form"
import classNames from "classnames"
import useError from "../hooks/useError"
import Input from "./Input"
import Button from "./Button"
import Col from "./Col"

type Props = {
  onSuccess?(): void
  challengeId: number
}

const AddTaskForm: FC<Props> = ({ onSuccess, challengeId }) => {
  const [loading, setLoading] = useState<boolean>(false)

  const { handleSubmit, control, formState } = useForm<CreateTaskRequestSchema>()
  const { handleError } = useError()

  const onSubmit = async({
    alias,
    title,
    materialsKey,
    pdfKey,
    difficulty,
    maxScore
  }: CreateTaskRequestSchema): Promise<void> => {
    try {
      setLoading(true)
      await TasksService.createTask({
        handler: { challengeId },
        alias,
        title,
        materialsKey,
        pdfKey,
        difficulty: Number(difficulty),
        maxScore: Number(maxScore)
      })
      if (onSuccess) {
        onSuccess()
      }
    } catch (err) {
      handleError(err)
    }
    setLoading(false)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={classNames("grid grid-cols-12 gap-2", loading && "opacity-50 pointer-events-none")}>
      <Col lg={6}>
        <Controller
          name="title"
          control={control}
          rules={{ required: "Campo Obbligatorio" }}
          render={({ field: { onChange, value } }): ReactElement => {
            return (
              <Input className="mb-3" value={value} onChange={onChange} label="Titolo" error={formState.errors.title?.message} />
            )
          }}
        />
      </Col>

      <Col lg={6}>
        <Controller
          name="alias"
          control={control}
          rules={{ required: "Campo Obbligatorio" }}
          render={({ field: { onChange, value } }): ReactElement => {
            return (
              <Input className="mb-3" value={value} onChange={onChange} label="Alias" error={formState.errors.title?.message} />
            )
          }}
        />

      </Col>

      <Col lg={6}>
        <Controller
          name="materialsKey"
          control={control}
          rules={{ required: "Campo Obbligatorio" }}
          render={({ field: { onChange, value } }): ReactElement => {
            return (
              <Input className="my-3" value={value} onChange={onChange} label="Materiali" error={formState.errors.materialsKey?.message} />
            )
          }}
        />
      </Col>

      <Col lg={6}>
        <Controller
          name="pdfKey"
          control={control}
          rules={{ required: "Campo Obbligatorio" }}
          render={({ field: { onChange, value } }): ReactElement => {
            return (
              <Input className="my-3" value={value} onChange={onChange} label="PDF" error={formState.errors.pdfKey?.message} />
            )
          }}
        />
      </Col>

      <Col lg={6}>
        <Controller
          name="maxScore"
          control={control}
          rules={{ required: "Campo Obbligatorio" }}
          render={({ field: { onChange, value } }): ReactElement => {
            return (
              <Input className="my-3" value={value} onChange={onChange} label="Punteggio Massimo" error={formState.errors.maxScore?.message} />
            )
          }}
        />
      </Col>

      <Col lg={6}>
        <Controller
          name="difficulty"
          control={control}
          rules={{ required: "Campo Obbligatorio" }}
          render={({ field: { onChange, value } }): ReactElement => {
            return (
              <Input className="mt-3" value={value} onChange={onChange} label="Difficoltà" error={formState.errors.difficulty?.message} />
            )
          }}
        />

      </Col>
      <Col>
        <Button type="submit" className="mt-3 w-full">Crea Task</Button>
      </Col>
    </form>
  )
}

export default AddTaskForm